var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"p-2"},[_c('img',{attrs:{"src":`/static/images/icons/${_vm.data.icon}-icon.svg`,"alt":`Icon ${_vm.data.icon}`}}),_c('h2',{staticClass:"font-semibold"},[_vm._v(_vm._s(_vm.data.title))]),_c('p',[_vm._v(_vm._s(_vm.data.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }